import styles from "../styles/Header.module.css";
import NavBar from "./NavBar";

const Header = ({ title, subtitle }) => {
  return (
    <>
    <header className={styles.header}>
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </header>
          <NavBar />
    </>
  );
};

export default Header;
